import { useId } from "react";

export const CrownMark = ({ size = 28, className = "" }) => {
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <path
        d="M4.5 21.5 6.7 10 12.7 15.8 16 7 19.3 15.8 25.3 10 27.5 21.5Z"
        fill={`url(#${id})`}
        stroke="#E5C158"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <rect x="5" y="23.3" width="22" height="2.5" rx="1.25" fill="#D4AF37" />
      <defs>
        <linearGradient id={id} x1="4" y1="7" x2="28" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F0D98C" />
          <stop offset="1" stopColor="#C59B27" />
        </linearGradient>
      </defs>
    </svg>
  );
};
